import React, { useState, FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AuthFormModal from '../AuthFormModal';
import HerdFormModal from '../HerdFormModal';
import UpdateAvatarModal from '../UpdateAvatarModal';
import UserAvatar from '../UserAvatar';
import storageService from '../../utils/localStorage';

import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

interface MobileUserMenuProps {
  user: any;
  handleLogout: () => void;
}

const MobileUserMenu: FC<MobileUserMenuProps> = ({ user, handleLogout }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const userBtnMobSx = { display: 'flex', alignItems: 'center', gap: 1 };
  const avatarSx = { width: 'var(--layout-compact-avatar)', height: 'var(--layout-compact-avatar)' };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleClose();
    handleLogout();
  };

  const loggedUser = storageService.loadUser() || user;

  return (
    <div>
      {loggedUser ? (
        <IconButton onClick={handleMenu} sx={userBtnMobSx} size="large">
          {/* frame="none": nav chrome shows who you are, not what you own. */}
          <UserAvatar user={loggedUser as any} frame="none" sx={avatarSx} />
        </IconButton>
      ) : (
        <IconButton onClick={handleMenu} color="primary" size="large">
          <MoreVertIcon color="primary" />
        </IconButton>
      )}
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {loggedUser ? (
          <div>
            <MenuItem
              component={RouterLink as any}
              to={`/u/${loggedUser.username}`}
              onClick={handleClose}
            >
              <ListItemIcon>
                <AccountCircleIcon style={{ marginRight: 'var(--space-icon-gap)' }} /> My Profile
              </ListItemIcon>
            </MenuItem>
            <MenuItem
              component={RouterLink as any}
              to={`/u/${loggedUser.username}/achievements`}
              onClick={handleClose}
            >
              <ListItemIcon>
                <EmojiEventsIcon style={{ marginRight: 'var(--space-icon-gap)' }} /> Achievements
              </ListItemIcon>
            </MenuItem>
            <HerdFormModal type="menu" handleCloseMenu={handleClose} />
            <UpdateAvatarModal
              handleCloseMenu={handleClose}
              user={loggedUser}
            />
            <MenuItem onClick={handleLogoutClick}>
              <ListItemIcon>
                <PowerSettingsNewIcon style={{ marginRight: 'var(--space-icon-gap)' }} /> Logout
              </ListItemIcon>
            </MenuItem>
          </div>
        ) : (
          <div>
            <AuthFormModal closeMobileMenu={handleClose} />
          </div>
        )}
      </Menu>
    </div>
  );
};

export default MobileUserMenu;
